export const INFERENTIAL_STATISTICS = 'INFERENTIAL_STATISTICS';

export const ONE_SAMPLE_T = 'ONE_SAMPLE_T';
export const TWO_SAMPLE_T = 'TWO_SAMPLE_T';
export const ONE_SAMPLE_PROPORTION = 'ONE_SAMPLE_PROPORTION';
export const TWO_SAMPLE_PROPORTION = 'TWO_SAMPLE_PROPORTION';
export const PAIRED_T = 'PAIRED_T';
export const CHI_SQUARE_GOODNESS_OF_FIT = 'CHI_SQUARE_GOODNESS_OF_FIT';
export const CHI_SQUARE_TEST_FOR_INDEPENDENCE = 'CHI_SQUARE_TEST_FOR_INDEPENDENCE';
export const CHI_SQUARE_TEST_FOR_HOMOGENEITY = 'CHI_SQUARE_TEST_FOR_HOMOGENEITY';
export const ANOVA = 'ANOVA';


export const GREATER_THAN_VALUE = '>';
export const LESS_THAN_VALUE = '<';
export const NOT_EQUAL_VALUE = '≠';

export const GREATER_THAN = `Greater than ${GREATER_THAN_VALUE}`;
export const LESS_THAN = `Less than ${LESS_THAN_VALUE}`;
export const NOT_EQUAL = `Not equal  ${NOT_EQUAL_VALUE}`;

export const HYPOTHESIS_MEAN = 'hypothesisMean';
export const CONFIDENCE_INTERVAL = 'confidenceInterval';

export const DIFFERENCE_DATA = 'differenceData';
export const RAW_DATA = 'rawData';

export const EQUAL_PROPORTION = 'equalProportion';
export const NON_EQUAL_PROPORTION = 'nonEqualProportion';

export const ITALIC_P = '\uD835\uDC5D';

export const optionsInferentialProcedure = [
  { value: ONE_SAMPLE_T, label: 'One Sample 𝘵', text: 'One Sample 𝘵' },
  {
    value: ONE_SAMPLE_PROPORTION,
    label: 'One Sample Proportion',
    text: 'One Sample Proportion'
  },
  { value: TWO_SAMPLE_T, label: 'Two Sample 𝘵', text: 'Two Sample 𝘵' },
  {
    value: TWO_SAMPLE_PROPORTION,
    label: 'Two Sample Proportion',
    text: 'Two Sample Proportion'
  },
  { value: PAIRED_T, label: 'Paired 𝘵', text: 'Paired 𝘵' },
  {
    value: CHI_SQUARE_GOODNESS_OF_FIT,
    label: 'Chi-Square Goodness-of-Fit',
    text: 'Chi-Square Goodness-of-Fit'
  },
  {
    value: CHI_SQUARE_TEST_FOR_INDEPENDENCE,
    label: 'Chi-Square Test for Independence',
    text: 'Chi-Square Test for Independence'
  },
  {
    value: CHI_SQUARE_TEST_FOR_HOMOGENEITY,
    label: 'Chi-Square Test for Homogeneity',
    text: 'Chi-Square Test for Homogeneity'
  },
  { value: ANOVA, label: ANOVA, text: ANOVA }
];
